export const LOGIN = '/login';
export const ROOT = '/inicio';
export const DEPARTAMENTOS = '/departamentos';
export const MIS_RECURSOS = '/mis-recursos';
export const MIS_MATERIAS = '/mis-materias';
export const RECURSOS = '/revision-de-recursos';
export const AUDITORIA = '/auditoria';
